import React from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";

const Copyable = ({ text }) => {
    return (
        <CopyToClipboard text={text} className="copyable">
            <span>{text}</span>
        </CopyToClipboard>
    )
};

export default Copyable;